import icons from '../../../types/IconTypes';

const align = [
  { align: 'left', icon: icons.ALIGN_LEFT },
  { align: 'center', icon: icons.ALIGN_CENTER },
  { align: 'right', icon: icons.ALIGN_RIGHT },
];

export default align;
